export enum CoreCreditRequestBatch {
    BoxLine = "BoxLine",
    CrateLine = "CrateLine",
    DropShipRemanLine = "DropShipRemanLine",
}
